import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import classNames from 'classnames';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import MemberList from './list';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import styles from './style.scss';

@inject('translationsStore', 'teamsStore', 'usersStore', 
    'teamUsersCheckboxListStore', 'teamMembersStore') @observer
export default class AddTeamMemberDialog extends Component {

    state = {
        openAddDialog: false,
        openErrorDialog: false
    }

    handleAddTeamOnChange = e => this.props.teamsStore.setTeamName(e.target.value);

    closeAddDialog = (e) => {
        this.setState({ 
            openAddDialog: false
        });

        this.props.teamUsersCheckboxListStore.resetSelectableList();
    }

    openAddDialog = () => {

        this.setState({ 
            openAddDialog: true
        });
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }
    
    addTeamMember = () => {

        this.props.teamMembersStore.putTeamUsers(this.props.teamsStore.selectedTeamId).then(() => {

            this.closeAddDialog();
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('TEAM_MEMBER_ADD_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({level, message});
        })
        .catch(() =>{

            this.openErrorDialog();
        });
    }

    render() {

        const isSelected = this.props.teamUsersCheckboxListStore.selectableList.filter(s => s.selected == true);

        const actions = [
            <span
                className='portal-blank-button'
                onClick={this.closeAddDialog}
            >
                {this.props.translationsStore.translate('CANCEL')}
            </span>,
            <Button 
                onClick={this.addTeamMember}
                disabled={isSelected.length === 0}
                text={this.props.translationsStore.translate('ADD_MEMBERS') 
                    + `${this.props.teamUsersCheckboxListStore.selectedTeamUsers}`}
                inProgress={this.props.teamMembersStore.addingUserToTeam}>
            </Button>
        ];

        const customContentStyle = {
            width: '735px',
            backgroundColor: '#D82D49',
            padding: 0
        };

        const title = <span>{this.props.translationsStore.translate('ERROR')}</span>;

        return(<div>
                    <Button
                        onClick={this.openAddDialog}
                        text={this.props.translationsStore.translate('ADD_MEMBER')}>
                    </Button>
                    <Dialog 
                        className='portal-confirm-dialog add-team-member-dialog'
                        titleClassName='portal-confirm-dialog-header alert-confirm'
                        actionsContainerClassName='portal-confirm-dialog-actions top-border'
                        actions={actions}
                        bodyStyle={{
                            height: '485px',
                            padding: 0
                        }}
                        contentStyle={customContentStyle}
                        open={this.state.openAddDialog}
                    >
                        <div className={classNames(styles.ldapAddGroupsMainWrapper)}>
                            <div className={classNames(styles.ldapAddGroupsBody)}>
                                <DialogHeader
                                    title={this.props.translationsStore.translate('ADD_TEAM_MEMBER')}
                                    displayCloseButton
                                    closeClick={this.closeAddDialog}
                                />
                                <div className='team-member-list-content'>
                                    <MemberList addTeamMember={this.addTeamMember} />
                                </div>
                            </div>
                        </div>
                    </Dialog>
                    <ErrorDialog 
                        show={this.state.openErrorDialog}
                        onConfirm={this.closeErrorDialog}
                        deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                        closeDeleteDialog={this.closeErrorDialog}
                        titleText={title}
                        contentText={this.props.teamMembersStore.putTeamUsersErrorMessage} />
                </div>
        );
    }
}